export function initializeDownloadLinks() {
  document.querySelectorAll('[href="/uploads/images/HOM_map_11_23.jpg"]').forEach((link) => {
    link.setAttribute('download', 'ttw-property-map.jpg');
  });
}
